var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dynamic-vector-properties-wrapper" },
    [
      _c(_setup.CSelect, {
        staticClass: "mb-2",
        attrs: {
          options: _setup.CONFIG_OPTIONS.quality,
          label: "Quality",
          "model-transform": _setup.valueReducer,
          disabled: _setup.isDisabled,
        },
        on: { input: _setup.updateImageToImageConfig },
        model: {
          value: _setup.model.quality,
          callback: function ($$v) {
            _vm.$set(_setup.model, "quality", $$v)
          },
          expression: "model.quality",
        },
      }),
      _vm._v(" "),
      _c(_setup.CSelect, {
        staticClass: "mb-2",
        attrs: {
          options: _setup.CONFIG_OPTIONS.size,
          label: "Size",
          "model-transform": _setup.valueReducer,
          disabled: _setup.isDisabled,
        },
        on: { input: _setup.updateImageToImageConfig },
        model: {
          value: _setup.model.size,
          callback: function ($$v) {
            _vm.$set(_setup.model, "size", $$v)
          },
          expression: "model.size",
        },
      }),
      _vm._v(" "),
      _c(_setup.CSelect, {
        staticClass: "mb-2",
        attrs: {
          options: _setup.CONFIG_OPTIONS.background,
          label: "Background",
          "model-transform": _setup.valueReducer,
          disabled: _setup.isDisabled,
        },
        on: { input: _setup.updateImageToImageConfig },
        model: {
          value: _setup.model.background,
          callback: function ($$v) {
            _vm.$set(_setup.model, "background", $$v)
          },
          expression: "model.background",
        },
      }),
      _vm._v(" "),
      _c(_setup.CCheckbox, {
        staticClass: "mt-4 mb-2",
        attrs: {
          label:
            "Stream partial images (may incur extra tokens) - experimental",
          disabled: _setup.isDisabled,
        },
        on: { input: _setup.updateImageToImageConfig },
        model: {
          value: _setup.model.stream,
          callback: function ($$v) {
            _vm.$set(_setup.model, "stream", $$v)
          },
          expression: "model.stream",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }